var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92 7.25 6.73 4.06 3.54 7.25c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L6.2 2.47a.75.75 0 0 1 1.06 0l3.72 3.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98 21V3c0-.41.34-.75.75-.75s.75.34.75.75v18c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM16.75 21.53l-3.72-3.72a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.19 3.19 3.19-3.19c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.72 3.72a.75.75 0 0 1-1.06 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.52 21V3c0-.41.34-.75.75-.75s.75.34.75.75v18a.749.749 0 1 1-1.5 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineArrow3);
export default __webpack_public_path__ + "static/media/vuesax-outline-arrow-3.3f8743519ea7bd21bb65972e25e5c878.svg";
export { ForwardRef as ReactComponent };